<template>
  <div>
    <v-container
      fluid>
      <v-data-iterator
        :items="acoes"
        :search="filtro"
        :hide-default-footer="true"
        :disable-pagination="true"
        :custom-filter="filtrarCards">
        <template v-slot:default="props">
          <v-row class="pl-2">
            <v-col cols="12" v-for="(acao, index) in props.items"
              :key="index"
              sm="6"
              lg="3">
              <v-hover>
                <v-card
                  class="mx-auto"
                  style="border-radius: 6px; height: 100%"
                  slot-scope="{ hover }"
                  :class="`elevation-${hover ? 6 : 2}`">
                  <v-card-title style="height: 25%">
                    <span>{{ acao.nomeTipoAcao }}</span>
                    <v-spacer />
                    <status style="display:block;"
                        :status="acao.passoGeral.status || 'EM_CADASTRO'"
                        :tooltip="acao.passoGeral.status || 'EM_CADASTRO'"/>
                  </v-card-title>
                  <v-card-text class="font-weight-light title" v-if="acao.passoGeral.descricao "style="height: 36%;padding:16px">
                    {{ acao.passoGeral.descricao }}
                  </v-card-text>
                  <v-card-text class="font-weight-light title" v-if="!acao.passoGeral.descricao "style="height: 36%;padding:16px">
                    {{ acao.passoGeral.numeroContrato }} - {{ acao.passoGeral.codCliente }} - {{ acao.passoGeral.notaFiscal }}
                  </v-card-text>
                  <v-card-actions class=pr-0 style="height: 39%">
                    <v-list-item class="grow pa-0">
                      <v-list-item-content class="PlanejamentoContratoFormAcoesControleCard__color px-2 pb-0">
                        <v-list-item-title>{{ montarData(acao) }}</v-list-item-title>
                        <v-list-item-subtitle>
                          <v-row align="center" justify="end" right class="pa-3 mr-1">
                            <div>
                              <v-tooltip right>
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    text
                                    icon
                                    v-show="podeClonar(acao)"
                                    @click="copiaAcao(acao.index)"
                                    v-on="on"
                                    color="rgba(0,0,0,.54)"
                                    class="PlanejamentoContratoFormAcoesControleCard__btn"
                                    >
                                    <v-icon>library_add</v-icon>
                                  </v-btn>
                                </template>
                                <span>
                                  {{$t('label.copiar_acao')}}
                                </span>
                              </v-tooltip>
                              <v-tooltip right>
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    text
                                    icon
                                    v-show="podeExcluir(acao) && canEdit"
                                    @click="confirmaRemoverAcao(acao.index)"
                                    v-on="on"
                                    color="rgba(0,0,0,.54)"
                                    class="PlanejamentoContratoFormAcoesControleCard__btn">
                                    <v-icon>remove_circle</v-icon>
                                  </v-btn>
                                </template>
                                <span>
                                  {{$t('label.excluir_a_acao')}}
                                </span>
                              </v-tooltip>
                              <v-tooltip right>
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    text
                                    icon
                                    @click="editaVisualizaAcao(acao, acao.index)"
                                    v-on="on"
                                    color="rgba(0,0,0,.54)"
                                    class="PlanejamentoContratoFormAcoesControleCard__btn">
                                    <v-icon v-if="permiteEditar(acao) && canEdit">edit</v-icon>
                                    <v-icon v-else>visibility</v-icon>
                                  </v-btn>
                                </template>
                                <span v-if="permiteEditar(acao) && canEdit">
                                  {{$t('label.editar_a_acao')}}
                                </span>
                                <span v-else>
                                  {{$tc('label.detalhe', 2)}}
                                </span>
                              </v-tooltip>
                              <v-tooltip right>
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    text
                                    icon
                                    v-show="podeCancelar(acao)"
                                    @click="confirmaCancelarAcao(acao.index)"
                                    v-on="on"
                                    color="rgba(0,0,0,.54)"
                                    class="PlanejamentoContratoFormAcoesControleCard__btn">
                                    <v-icon>clear</v-icon>
                                  </v-btn>
                                </template>
                                <span>
                                  {{$t('label.cancelar')}}
                                </span>
                              </v-tooltip>
                              <v-tooltip right>
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    text
                                    icon
                                    v-show="podeCancelarFluxo(acao)"
                                    @click="confirmaCancelarFluxo(acao.index)"
                                    v-on="on"
                                    color="rgba(0,0,0,.54)"
                                    class="PlanejamentoContratoFormAcoesControleCard__btn">
                                    <v-icon>clear</v-icon>
                                  </v-btn>
                                </template>
                                <span>
                                  {{$t('label.cancelar')}}
                                </span>
                              </v-tooltip>
                              <v-tooltip right>
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    text
                                    icon
                                    v-show="podeCancelarAcaoAgrupadaAprovada(acao)"
                                    @click="confirmaCancelarAcaoAgrupadaAprovada(acao)"
                                    v-on="on"
                                    color="rgba(0,0,0,.54)"
                                    class="PlanejamentoContratoFormAcoesControleCard__btn">
                                    <v-icon>clear</v-icon>
                                  </v-btn>
                                </template>
                                <span>
                                  {{$t('label.cancelar')}}
                                </span>
                              </v-tooltip>
                              <v-tooltip right>
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    text
                                    icon
                                    v-show="permiteSolicitarAprovacao(acao) && canEdit &&
                                      usuarioPodeSolicitarEsseTipoAcao(acao)"
                                    @click="solicitarAprovacao(acao)"
                                    v-on="on"
                                    color="rgba(0,0,0,.54)"
                                    class="PlanejamentoContratoFormAcoesControleCard__btn">
                                    <v-icon>send</v-icon>
                                  </v-btn>
                                </template>
                                <span>
                                  {{$t('label.solicitar_aprovacao')}}
                                </span>
                              </v-tooltip>
                              <v-tooltip right>
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    text
                                    icon
                                    v-show="acaoEmAnalise(acao) && canEdit &&
                                      !temFluxoContrato && !isAcaoAgrupadora(acao)"
                                    @click="confirmarExecutarAnalise(acao.index)"
                                    v-on="on"
                                    color="rgba(0,0,0,.54)"
                                    class="PlanejamentoContratoFormAcoesControleCard__btn">
                                    <v-icon>edit</v-icon>
                                  </v-btn>
                                </template>
                                <span>
                                  {{$tc('label.executar_analise', 1)}}
                                </span>
                              </v-tooltip>
                            </div>
                            <div v-if="!isAcaoAgrupadora(acao)">
                              <planejamento-acao-fluxo
                                  :ref="`acaoFluxo${acao.index}`"
                                  :key="acao.id"
                                  :idAcao="acao.id"
                                  :acao-de-contrato="true"
                                  :status="acao.passoGeral.status"
                                  :contrato-tem-fluxo="temFluxoContrato"
                                  :exibir-justificativa="!temFluxoContrato"
                                  :exibir-justificativa-em-cadastro="acao.passoGeral.temFluxo"
                                  @recarregar="recarregarDados(acao.id, acao.index)"
                                  :exibir-acompanhamento="acao.passoGeral.temFluxo"
                                  @PlanejamentoAcaoFluxoFuncoes__justificativa
                                      ="(j) => preencherJustificativa(acao, j)"/>
                            </div>
                          </v-row>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-card-actions>
                </v-card>
              </v-hover>
            </v-col>
          </v-row>
        </template>
      </v-data-iterator>
    </v-container>
    <confirm
      ref="mensagensAvisoDialog"
      :message="mensagemAviso"
      :persistent="true"
      hide-disagree
      :agree-label="$t('label.ok')"/>
    <confirm
      ref="removerAcaoDialog"
      :message="msgRemocaoAcao"
      :persistent="true"
      @agree="removeAcao"/>
    <confirm
      ref="executarAnaliseDialog"
      :message="msgExecutarAnalise"
      :persistent="true"
      @agree="executarAnalise"/>
    <confirm
      ref="fluxoSemUsuarioClienteDialog"
      :message="msgFluxoSemAprovador"
      :persistent="true"
      @agree="iniciaFluxo"/>
    <planejamento-acao-form-usuario-cliente
      ref="modalUsuarioCliente"
      :title="indModoVarejo ? $tc('title.selecao_aprovador_fornecedor', 1) : $tc('title.selecao_aprovador_cliente', 1)"
      :passoCliente="passoCliente"
      @selecionarUsuarioCliente="selecionaAprovadorPassoClienteFornecedor"/>
    <planejamento-contrato-dialog-cancelar-acao
      ref="cancelarAcaoDialog"
      :cancelarAcao="funcCancelar"
      :mensagem="mensagemCancelar"/>
    <planejamento-contrato-dialog-cancelar-acao-aprovada
      ref="cancelarAcaoAprovadaDialog"
      :cancelarAcao="funcCancelar"
      :mensagem="mensagemCancelar"/>
    <planejamento-contrato-form-acoes-apuracoes-agrupadas
      ref="modalApuracoesAgrupadas"
      @SOLICITAR_APROVACAO="executaSolicitarAprovacao"
      @ERRO_CONFLITO_ACAO_AGRUPADORA="exibirErroConflitoAcaoAgrupadora"/>
  </div>
</template>
<script>
import PlanejamentoAcaoFluxo from '@/spa/planejamento-acao/PlanejamentoAcaoFluxo';
import { generateComputed } from '../../../../common/functions/roles-computed-generator';
import Status from '../../../../shared-components/Status';
import Confirm from '../../../../shared-components/vuetify/dialog/Confirm';
import PlanejamentoContratoFormAcoesControleItens from './PlanejamentoContratoFormAcoesControleItens';
import PlanejamentoContratoDialogCancelarAcao from './PlanejamentoContratoDialogCancelarAcao';
import PlanejamentoContratoDialogCancelarAcaoAprovada from './PlanejamentoContratoDialogCancelarAcaoAprovada';
import PlanejamentoAcaoFormUsuarioCliente from '../../../planejamento-acao/form/PlanejamentoAcaoFormUsuarioCliente';
import PlanejamentoContratoFormAcoesApuracoesAgrupadas from './PlanejamentoContratoFormAcoesApuracoesAgrupadas';

export default {
  props: {
    acoes: {
      type: Array,
      required: true,
    },
    acoesFormatadas: {
      type: Array,
      required: true,
    },
    tiposAcaoSolicitaveis: {
      type: Array,
      required: true,
    },
    somenteLeitura: Boolean,
  },
  mixins: [PlanejamentoContratoFormAcoesControleItens],
  components: {
    PlanejamentoAcaoFormUsuarioCliente,
    Confirm,
    Status,
    PlanejamentoContratoDialogCancelarAcao,
    PlanejamentoContratoDialogCancelarAcaoAprovada,
    PlanejamentoAcaoFluxo,
    PlanejamentoContratoFormAcoesApuracoesAgrupadas,
  },
  watch: {
    acoes() {
      this.defineIndicesGlobais();
    },
  },
  computed: {
    ...generateComputed('CONTRATO', [
      'canEdit',
    ]),
  },
  methods: {
    forcaAtualizacao() {
      const old = this.filtro;
      this.filtro = `${this.filtro} `;
      this.$forceUpdate();
      setTimeout(() => { this.filtro = old; });
    },
    filtrarCards(acoes, filtro) {
      return acoes.filter((acao) => (acao.passoGeral.descricao || '')
        .toUpperCase().indexOf(filtro.toUpperCase()) >= 0 || (acao.passoGeral.numeroContrato || '')
        .toUpperCase().indexOf(filtro.toUpperCase()) >= 0 || (acao.passoGeral.notaFiscal || '')
        .toUpperCase().indexOf(filtro.toUpperCase()) >= 0 || (acao.passoGeral.nomCliente || '')
        .toUpperCase().indexOf(filtro.toUpperCase()) >= 0 || acao.nomeTipoAcao
        .toUpperCase().indexOf(filtro.toUpperCase()) >= 0);
    },
    usuarioPodeSolicitarEsseTipoAcao(acao) {
      return this.tiposAcaoSolicitaveis.includes(acao.nomeTipoAcao);
    },
  },
  beforeMount() {
    this.defineIndicesGlobais();
  },
};
</script>

<style scoped>
.PlanejamentoContratoFormAcoesControleCard__color {
  color: rgba(0,0,0,.54);
  font-size: 0,85rem;
}
</style>
